import { Locale } from './locale.js';

const UNITS_COUNT = 4;
const SIZE_UNITS = {
    [Locale.RU]: ['Б', 'КБ', 'МБ', 'ГБ'],
    [Locale.EN]: ['B', 'KB', 'MB', 'GB'],
};

export { SIZE_UNITS, UNITS_COUNT };
